module.exports = __webpack_public_path__ + "static/images/containers/ChallengesResults/images/challenges-rewarding-bg.dc929822.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengesResults/images/challenges-rewarding-bg.jpg
// module id = 2879
// module chunks = 11